import { render, staticRenderFns } from "./protocol_topic_setting_dialog.vue?vue&type=template&id=77b96b12"
import script from "./protocol_topic_setting_dialog.vue?vue&type=script&lang=js"
export * from "./protocol_topic_setting_dialog.vue?vue&type=script&lang=js"
import style0 from "./protocol_topic_setting_dialog.vue?vue&type=style&index=0&id=77b96b12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports